import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import PrimaryButton from "./PrimaryButton";
import DynamicIcon from "./DynamicIcon";

function DeleteDialog({ open, onClose, title, onDelete }: { open: boolean, onClose: () => void, title: string, onDelete: () => Promise<void> }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div
            onClick={onClose}
            className="p-2 hover:bg-hover-light-gray dark:hover:bg-border-dark-gray cursor-pointer rounded-[4px] font-semibold">
            <h1 className="text-sm text-gray-900 dark:text-white" >Cancelar</h1>
          </div>
          <div className="w-[180px]">
            <PrimaryButton buttonColor="red" startIcon={<DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-white" />} onClick={async () => await onDelete()}>Excluir</PrimaryButton>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteDialog;